// Cart group validation

function initCartValidator() {
  document.addEventListener('DOMContentLoaded', function () {
    async function validateCustomizationProductsCart() {
      let cart;
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        cart = await res.json();
      } catch (err) {
        return false;
      }

      const groups = {};
      for (const item of cart.items) {
        const groupId = item.properties && item.properties._groupId;
        if (groupId) {
          if (!groups[groupId]) groups[groupId] = [];
          groups[groupId].push(item);
        }
      }
      const itemsToRemove = [];
      for (const groupId in groups) {
        const groupItems = groups[groupId];
        // Get all unique ids present in _customizationProducts of the group's items
        let expectedIds = new Set();
        groupItems.forEach((item) => {
          const idsStr = item.properties && item.properties._customizationProducts;
          if (idsStr) {
            idsStr.split(',').forEach((id) => expectedIds.add(id));
          }
          // Also add the item's own id
          if (item.id) expectedIds.add(String(item.id));
        });
        // Get all ids actually present in the group
        const presentIds = new Set(groupItems.map((item) => String(item.id)));
        // If at least one expected id is missing, remove all items in the group
        const allPresent = Array.from(expectedIds).every((id) => presentIds.has(id));
        if (!allPresent) {
          groupItems.forEach((item) => itemsToRemove.push(item.key));
        }
      }
      if (itemsToRemove.length > 0) {
        await Promise.all(
          itemsToRemove.map((key) => {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 }),
            });
          }),
        );

        window.location.reload();
        return false;
      }

      return true;
    }
    validateCustomizationProductsCart();
  });
}

initCartValidator();
